import { Component, Input, OnInit } from '@angular/core';
import { LoanSummary } from './loan-summary.model';

@Component({
  selector: 'loan-summary-card',
  templateUrl: './loan-summary-card.component.html',
  styleUrls: ['./loan-summary-card.component.scss'],
  standalone: false
})
export class LoanSummaryCardComponent implements OnInit {

  @Input()
  loanSummary: LoanSummary;

  @Input()
  showExplanationSectionForMenuStatusIcons: boolean;

  protected iconsHelpOpen: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  toggleIconsHelp() {
    this.iconsHelpOpen = !this.iconsHelpOpen;
  }

}
